<template>
		<div class="content crfff ac-page my-account-page">
      <Header></Header>
      <div class="chances-top disflex crfff ac">
        <div @click="back">
          <img width="20" src="../../static/images/back.png"  class="nav-icon-left" />
          <div>{{$t('Back')}}</div>
        </div>
      </div>
      <div class="info">
        <div class="nav ac" style="margin-top: -0.3rem;">
          <span class="">{{$t('profile')}}</span>
        </div>
        <div class="account-top-bg">
          <div class="mt20 ac">
            <img width="120" src="static/images/account.png" />
          </div>
          <div class="ac">
            <div v-if="isEdit" class="flex" style="margin:20px 0;">
              <input class="fen" style="margin:0px 10px 0 0;width:70%;font-size: 28px;color:#fff" v-model="nickname" />
              <button class="button" style="width: 30%;" @click="editSub">{{$t('Submit')}}</button>
            </div>
            <div v-else>
              <span class="name-span app-en">{{info.nickname}}</span>
              <span class=" crff1d4f fs33" @click="editName">
                <img width="20" class="edit" src="static/images/edit.png" />
              </span>
            </div>
          </div>
        </div>
        <div class="mt50">
          <div class="fwb">
            <div class="fen disflex">
                <div class="name fw7 fs20">
                 {{$t('phoneNumber')}}:
                </div>
                <span class="fs26">{{info.mobile}}</span>
            </div>
          </div>
          <div class="fwb">
            <div class="fen disflex">
                <div class="name fw7 fs20">
                  {{$t('SubscribedSince')}}
                </div>
              <span class="fs26">{{info.jointime}}</span>
            </div>
          </div>
          <div class="fwb">
            <div class="fen disflex">
              <div class="name fw7 fs20">
                {{$t('RemainingChances')}}
              </div>
              <span class="fs26">{{info.score}}</span>
            </div>
          </div>

          <div class="fwb">
            <div v-if="show_usub" class="name fw7" style="font-size: 35px;color: orangered">
              {{$t('unsub_tip')}}
            </div>
          </div>
        </div>
			</div>
		</div>
</template>
<script>
import Header from '../components/Header'
import Dialog from '../components/dialog'

export default {
    components:{
		Header,
    Dialog
    },
    data() {
        return {
          disAbled:'',
          isEdit:false,
          info:'',
          nickname:'',
          show_usub: false,

        }
    },
	watch: {

	},
	computed:{
	},
    mounted() {
		let that = this;
    },
	created(){
		this.getHome();

	},
    methods: {
		back(){
			this.$router.go(-1);
		},
    editName(){
      this.isEdit = true
      this.nickname = this.info.nickname
    },
    editSub(){
      let that =this;
      let data = {
        nickname:that.nickname
      }
      //that.$parent.loadModal(true);
      that.$api.post('/api/user/profile',data,r =>{
      	that.$parent.returnCode(r,function(){
      		//that.info = r.data
          that.isEdit = false
          that.getHome()
      		that.$parent.loadModal(false);
        });

      })
    },
		getHome(){
			let that =this;
			//that.$parent.loadModal(true);
			that.$api.post('/api/user/info',null,r =>{
				that.$parent.returnCode(r,function(){
					that.info = r.data
					that.$parent.loadModal(false);
          that.show_usub = r.data.show_usub
        });

			})
		},
	}
}
</script>
<style>
  .my-account-page {
    width: calc(100% + 2px);
    min-height: 100vh;
    margin-left: -1px;
    margin-right: -1px;
    overflow-x: hidden;
    background-color: #110d1d;
  }

  .my-account-page .info {
    background: transparent;
  }

  .fen .fs26{color:#7170a1;font-size: .2rem;margin-left: 5px;}
</style>



// WEBPACK FOOTER //
// src/page/myAccount.vue